import { render, staticRenderFns } from "./biToolTip.vue?vue&type=template&id=2a789478&scoped=true&"
import script from "./biToolTip.vue?vue&type=script&lang=js&"
export * from "./biToolTip.vue?vue&type=script&lang=js&"
import style0 from "./biToolTip.vue?vue&type=style&index=0&id=2a789478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a789478",
  null
  
)

export default component.exports